import { lang, locale, t } from "../../i18n";

export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

// 15 September 2026 / 15 сентября 2026 - Russian needs the genitive month,
// which only the day-and-month form of toLocaleDateString gives.
export const getLongDate = (date: string) => {
  const selectedDate = new Date(date);
  const dayAndMonth =
    lang === "ru"
      ? selectedDate.toLocaleDateString(locale, { day: "numeric", month: "long" })
      : selectedDate.getDate() +
        " " +
        selectedDate.toLocaleString(locale, { month: "long" });
  return dayAndMonth + " " + selectedDate.getFullYear();
};

export const getWeekday = (date: string) => {
  const selectedDate = new Date(date);
  return selectedDate.toLocaleString(locale, {
    weekday: "long",
  });
};

// MON, TUE... The table is Monday-first; getUTCDay() is Sunday-first.
export const getShortWeekday = (date: string) => {
  return t.weekdaysShort[(new Date(date).getUTCDay() + 6) % 7];
};

// 15.09.26 in English (as the mobile app shows it), 15.09.2026 in Russian.
export const get2DigitsDate = (date: string) => {
  const selectedDate = new Date(date);
  const year = selectedDate.getFullYear().toString();
  return [
    selectedDate.getDate().toString().padStart(2, "0"),
    (selectedDate.getMonth() + 1).toString().padStart(2, "0"),
    lang === "ru" ? year : year.slice(-2),
  ].join(".");
};

// the planning day doesn't roll over at midnight - "today" still means
// yesterday's plan until this hour, so late-night planning isn't cut off early
const DAY_ROLLOVER_HOUR = 4;

export const getEffectiveToday = () => {
  const now = new Date();
  const shifted = new Date(now.getTime() - DAY_ROLLOVER_HOUR * 60 * 60 * 1000);
  return shifted.toISOString().slice(0, 10);
};

export const addDaysToDateString = (date: string, days: number) => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result.toISOString().slice(0, 10);
};

// Padded because records from other clients may hold 9:30 rather than 09:30.
export const isLaterTime = (time: string, than: string) =>
  time.padStart(5, "0") > than.padStart(5, "0");
